import { ApiClient, createEndpoints } from '@icebreaker/api-client';
import { adminEnv } from '../config/env';

/**
 * Tek API istemcisi örneği. BİLEŞENLER BUNU DOĞRUDAN ÇAĞIRMAZ —
 * yalnızca sagalar kullanır (CLAUDE.md web/mobil kuralları, eslint ile zorlanır).
 *
 * Erişim jetonu BELLEKTE tutulur; yenileme jetonu HttpOnly çerezdedir ve
 * `admin` host'una özeldir — yani panelin oturumu web uygulamasının
 * oturumundan AYRIDIR (aynı origin kararının doğrudan sonucu).
 */
let accessToken: string | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export const apiClient = new ApiClient({
  baseUrl: adminEnv.apiUrl,
  getAccessToken: () => accessToken,
  getLocale: () => (typeof document === 'undefined' ? 'tr' : document.documentElement.lang || 'tr'),
  credentials: 'include',
  /*
   * ZAMAN AŞIMI: `fetch` varsayılan olarak sonsuza kadar bekler; sunucuya
   * ulaşılamadığında ekran sonsuz iskelette kalırdı (Blok 23 kalem 6c).
   * Sınırı ÇAĞIRAN koyar — panelde uzun süren yükleme yoktur.
   */
  timeoutMs: 30_000,
});

export const api = createEndpoints(apiClient);
